module.exports = __webpack_public_path__ + "static/media/info-icon.82713399.svg";